module.exports = __webpack_public_path__ + "img/bed.8a1c799d.svg";